import createPerSliceIdSelector from '../helpers/createPerSliceIdSelector';
import get from '../helpers/get';

export const getWaitlistContent = (state, sliceId) => get(state, ['waitlist', sliceId]);

export const isWaitlistSubmissionBusy = createPerSliceIdSelector(
  getWaitlistContent,
  content => get(content, ['busy']),
);

export const isWaitlistSubmissionSubmitted = createPerSliceIdSelector(
  getWaitlistContent,
  content => get(content, ['success']),
);

export const getWaitlistSubmissionError = createPerSliceIdSelector(
  getWaitlistContent,
  content => get(content, ['error']),
);

export const isWaitlistSubmissionFormVisible = createPerSliceIdSelector(
  getWaitlistContent,
  content => get(content, ['visible']),
);
